<template>
    <div>
        <div class="hidden sm:block relative py-6">
            <div class="absolute left-2 top-14 cursor-pointer w-28 h-11">
                <SwitchLang></SwitchLang>
            </div>
            <div class="flex justify-center">
                <img class="logo-size" src="../../../assets/logo/tipcoin-logo-top.png">
            </div>
            <ProfileLogin :modalController="modalController"></ProfileLogin>
        </div>
    </div>
</template>
<script>
import ProfileLogin from "./component/ProfileLogin.vue";
import SwitchLang from '@/components/Input/simple/SwitchLang.vue';

export default {
    name: 'TopBarLangDesktop',
    mixins: [],
    components: {
        ProfileLogin,
        SwitchLang
    },
    props: {
        modalController: { type: Object, required: true },
    },
    methods:{}

}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .logo-size {
        width: 100px;
        height: 90px;
    }
    .logo-mobile-size {
        width: 65px; //53px
        height: 58px;
    }
    .mobile-top {
        height: $topbar-height-mobile;
    }
</style>
